import React from 'react';
import ValueReferenceSelector from './value-reference-selector';
import '../../../css/values.less';
import { pathOr } from 'ramda';

class ValueReferenceSelectorWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        if (value)
            manywho.state.setComponent(this.props.id, { objectData: [value] }, this.props.flowKey);
        else
            manywho.state.setComponent(this.props.id, { objectData: [] }, this.props.flowKey);

        manywho.component.handleEvent(this, manywho.model.getComponent(this.props.id, this.props.flowKey), this.props.flowKey);
        this.forceUpdate();
    }

    render() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        manywho.log.info('Rendering Value Reference: ' + this.props.id);

        const objectDataRequestListFilter = pathOr(false, ['objectDataRequest', 'listFilter', 'where'], model);
        // If the Value Selector has a listFilter, we do the following check to protect the UI against a potentially misconfigured Type
        if (objectDataRequestListFilter) {
            // The UI should treat the contentType (ContentString, ContentBoolean, ContentObject etc.) as the primary information for the type of a Value
            // If the engine gives back a primitive type, we should ignore any Type it gives back
            // We are stripping this Type filter, which is incorrectly being added by a Page Condition in the Operator System Flow
            const contentTypeColumn = objectDataRequestListFilter.find(column => column.columnName === 'ContentType');
            // If the Type is said to be a Primitive type (not Object or List)
            if (contentTypeColumn && contentTypeColumn.contentValue !== 'ContentObject' && contentTypeColumn.contentValue !== 'ContentList') {
                // Then strip any Type filters because they don't make sense
                model.objectDataRequest.listFilter.where = objectDataRequestListFilter.filter(column => column.columnName !== 'TypeElementId');
            }
        }

        const state = manywho.state.getComponent(this.props.id, this.props.flowKey) || {};

        if (model.isVisible === false)
            return null;

        let selectedValue = null;
        if (state && state.objectData && state.objectData.length > 0)
            selectedValue = state.objectData[0];
        else
            selectedValue = (model.objectData || []).filter(objectData => objectData.isSelected)[0];

        let flowId = manywho.utils.getObjectDataProperty(model.tags, 'FlowId');
        const isLoading = state.loading !== null && typeof state.loading !== 'undefined';

        return <ValueReferenceSelector value={selectedValue}
            onChange={this.onChange}
            objectDataRequest={model.objectDataRequest}
            flowId={(flowId) ? flowId.contentValue : null}
            label={model.label}
            isRequired={model.isRequired}
            isValid={model.isValid !== false}
            validationMessage={model.validationMessage}
            isEnabled={model.isEnabled || !isLoading} />
    }

}

export default ValueReferenceSelectorWrapper;
